import { BaseTitle } from "@/components/atom/title/BaseTitle";
import { TitleProps } from "@mantine/core";

export const FormSubTitle = (props: TitleProps) => {
  return <BaseTitle size={"1.0rem"} c={"#000000"} weight={400} {...props} />;
};
